// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"33dfc0f1","239":"31dd9d58","455":"f3b2ab3e"}[chunkId] + ".chunk.js";
};